import { render, staticRenderFns } from "./PricePreview.vue?vue&type=template&id=773335aa&scoped=true&"
import script from "./PricePreview.vue?vue&type=script&lang=js&"
export * from "./PricePreview.vue?vue&type=script&lang=js&"
import style0 from "./PricePreview.vue?vue&type=style&index=0&id=773335aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773335aa",
  null
  
)

export default component.exports